import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Waiting() {
  const navigate = useNavigate();

  return (
    <div className="app-page centered">
      <div className="tg-only-icon">⏳</div>
      <h2>Заявка отправлена</h2>
      <p>Администратор рассмотрит вашу заявку и вы получите уведомление в Telegram.</p>
      <p className="hint">Обычно это занимает несколько минут.</p>
      <button type="button" className="btn-primary" onClick={() => navigate('/app', { replace: true })}>
        Проверить статус
      </button>
    </div>
  );
}
